import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ParentPaper } from '../atoms/parent-paper';
import { SwitchBox } from '../molecules/switch-box';
import { Group } from '../organisms/group';
import { FormattedValue } from '../store/formatted-value';
import { OemDistribution } from '../shared';
import { ButtonBox } from '../molecules/button-box';
import { variablesChange } from '../store/actions';

import { useDispatch } from '../store/utils';
import { InputBox } from '../molecules/input-box';
import { SelectBox } from '../molecules/select-box';
import { LicenseSelect } from '../organisms/license-select';
import { AppUpdate } from '../templates/settings/app-update';
import { VersionBox } from '../organisms/settings/version-box';

const ProductTest = () => {
  const dispatch = useDispatch();
  const startTest = () => {
    dispatch(variablesChange({ PRODUCT_TEST: true }));
  };

  return (
    <>
      <Group
        title={
          <FormattedMessage id="test-product.app" defaultMessage="Aplikace" />
        }
        layout="list"
      >
        <ParentPaper>
          <AppUpdate autoCheck />
          <VersionBox />
        </ParentPaper>
      </Group>
      <Group
        title={
          <FormattedMessage
            id="test-product.settings"
            defaultMessage="Nastavení"
          />
        }
        layout="list"
      >
        <ParentPaper>
          <SelectBox
            title={
              <FormattedMessage
                id="test-product.settings.distribution"
                defaultMessage="Distribuce"
              />
            }
            selectVariableId="OEM_DISTRIBUTION"
            options={[
              {
                label: (
                  <FormattedMessage
                    id="test-product.settings.distribution.Infigy"
                    defaultMessage="Infigy"
                  />
                ),
                value: OemDistribution.Infigy,
              },
              {
                label: (
                  <FormattedMessage
                    id="test-product.settings.distribution.Dzd"
                    defaultMessage="DZD"
                  />
                ),
                value: OemDistribution.DZD,
              },
              {
                label: (
                  <FormattedMessage
                    id="test-product.settings.distribution.solid_sun"
                    defaultMessage="SolidSun"
                  />
                ),
                value: OemDistribution.Solidsun,
              },
            ]}
            fullWidth
          />
          <LicenseSelect />
        </ParentPaper>
      </Group>
      <Group
        title={
          <FormattedMessage
            id="test-product.test"
            defaultMessage="Test zařízení"
          />
        }
        layout="list"
      >
        <ParentPaper>
          <InputBox
            title={
              <FormattedMessage
                id="test-product.test.serialNumber"
                defaultMessage="Výrobní číslo jednotky"
              />
            }
            subtitle={
              <FormattedMessage
                id="test-product.test.serialNumber.subtitle"
                defaultMessage="Bez výrobního čísla nelze zadat jméno testera a aktivovat test"
              />
            }
            inputVariableId="SERIAL_NUMBER"
            label={
              <FormattedMessage
                id="test-product.test.serialNumber.label"
                defaultMessage="Sériové číslo"
              />
            }
            fullWidth
          />
          <InputBox
            title={
              <FormattedMessage
                id="test-product.test.serialNumberSwitchboard"
                defaultMessage="Výrobní číslo rozvaděče"
              />
            }
            subtitle={
              <FormattedMessage
                id="test-product.test.serialNumberSwitchboard.subtitle"
                defaultMessage="Vyplnit v případě, že je zařízení v originálním rozvaděči"
              />
            }
            inputVariableId="SERIAL_NUMBER_SWITCHBOARD"
            label={
              <FormattedMessage
                id="test-product.test.serialNumberSwitchboard.label"
                defaultMessage="Sériové číslo"
              />
            }
            fullWidth
          />
          <InputBox
            title={
              <FormattedMessage
                id="test-product.test.tester"
                defaultMessage="Zařízení otestoval"
              />
            }
            visibility={{ variableId: 'SERIAL_NUMBER' }}
            subtitle={
              <FormattedMessage
                id="test-product.test.tester.subtitle"
                defaultMessage="Bez jména nelze aktivovat test"
              />
            }
            inputVariableId="PRODUCT_TESTER"
            label={
              <FormattedMessage
                id="settings.service.tester.label"
                defaultMessage="Jméno testera"
              />
            }
            fullWidth
          />
          <ButtonBox
            title={
              <FormattedMessage
                id="test-product.test.start"
                defaultMessage="Pokud je zařízení připojeno"
              />
            }
            visibility={{ variableIds: ['PRODUCT_TESTER', 'SERIAL_NUMBER'] }}
            buttonLabel={
              <FormattedMessage
                id="test-product.test.start.button"
                defaultMessage="Aktivovat test"
              />
            }
            onClick={startTest}
            fullWidth
          />
          <SwitchBox
            title={
              <FormattedMessage
                id="test-product.test.inverter-connect"
                defaultMessage="Připojení střídače"
              />
            }
            subtitle={<FormattedValue variableId="TEST_INFO_LABEL[0]" />}
            fullWidth
          />
          <SwitchBox
            title={
              <FormattedMessage
                id="test-product.test.internet-connect"
                defaultMessage="Připojení k internetu"
              />
            }
            subtitle={<FormattedValue variableId="TEST_INFO_LABEL[1]" />}
            fullWidth
          />
          <SwitchBox
            title={
              <FormattedMessage
                id="test-product.test.phase_1"
                defaultMessage="Test 1. fáze"
              />
            }
            subtitle={<FormattedValue variableId="TEST_INFO_LABEL[2]" />}
            fullWidth
          />
          <SwitchBox
            title={
              <FormattedMessage
                id="test-product.test.phase_2"
                defaultMessage="Test 2. fáze"
              />
            }
            subtitle={<FormattedValue variableId="TEST_INFO_LABEL[3]" />}
            fullWidth
          />
          <SwitchBox
            title={
              <FormattedMessage
                id="test-product.test.phase_3"
                defaultMessage="Test 3. fáze"
              />
            }
            subtitle={<FormattedValue variableId="TEST_INFO_LABEL[4]" />}
            fullWidth
          />
          <SwitchBox
            title={
              <FormattedMessage
                id="test-product.test.temp"
                defaultMessage="Teplotní čidlo"
              />
            }
            subtitle={<FormattedValue variableId="TEST_INFO_LABEL[5]" />}
            fullWidth
          />
          <SwitchBox
            title={
              <FormattedMessage
                id="test-product.test.switchboard"
                defaultMessage="Kontrola shody rozvaděče"
              />
            }
            subtitle={
              <FormattedMessage
                id="test-product.test.switchboard.subtitle"
                defaultMessage="Kontrola dotažení svorek, umístění komponentů, správné dimenze kabelů"
              />
            }
            switchVariableId="TEST_INFO[6]"
            fullWidth
          />
          <SwitchBox
            title={
              <FormattedMessage
                id="test-product.test.electricmeter"
                defaultMessage="Kontrola elektroměru"
              />
            }
            subtitle={
              <FormattedMessage
                id="test-product.test.electricmeter.subtitle"
                defaultMessage="Kontrola osazení elektroměru pro střídač"
              />
            }
            switchVariableId="TEST_INFO[7]"
            fullWidth
          />
          <SwitchBox
            title={
              <FormattedMessage
                id="test-product.test.DC"
                defaultMessage="Kontrola DC obvodu"
              />
            }
            subtitle={
              <FormattedMessage
                id="test-product.test.DC.subtitle"
                defaultMessage="Dotažení svorek, dimenze kabelů"
              />
            }
            switchVariableId="TEST_INFO[8]"
            fullWidth
          />
          <SwitchBox
            title={
              <FormattedMessage
                id="test-product.test.component"
                defaultMessage="Kontrola komponentů"
              />
            }
            subtitle={
              <FormattedMessage
                id="test-product.test.component.subtitle"
                defaultMessage="Je přibaleno čidlo, štítky, ...?"
              />
            }
            switchVariableId="TEST_INFO[9]"
            fullWidth
          />
          <SwitchBox
            title={
              <FormattedMessage
                id="test-product.test.license-info"
                defaultMessage="Test skončí za:"
              />
            }
            subtitle={<FormattedValue variableId="TEST_INFO_LABEL[11]" />}
            fullWidth
          />

          <SwitchBox
            title={
              <FormattedMessage
                id="test-product.test.license"
                defaultMessage="Licence"
              />
            }
            subtitle={<FormattedValue variableId="TEST_INFO_LABEL[10]" />}
            fullWidth
          />
        </ParentPaper>
      </Group>
    </>
  );
};

export default ProductTest;
